import  { useEffect, useState } from 'react'
import PageBodyWrapper from '../../components/PageBodyWrapper'
import { GraphQLPagination } from '../../components/common';
import { useSearchParams } from 'react-router-dom';
import { getQueryVariables } from '../../utils';
import AbandonedCartTable from '../../components/carts/abondonedCartTable';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";


const GET_CARTS = gql`
  query GetCarts(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    carts(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          dbId
          totalItems
          abandonedAt
          user {
            dbId
            fullName
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

function AbandonedCart() {
  const [isOpenStockCreateForm, setIsOpenStockCreateForm] = useState<boolean>(false)
  const [isOpenStockFilter, setISOpenStockFilter] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams();

 

  const { data, loading, error, refetch } = useQuery(GET_CARTS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });


  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);


  const fetchStockTransfers = () => {
    refetch();
  }


  return (
    <PageBodyWrapper>

      <AbandonedCartTable data={data?.carts?.edges || []} refresh={fetchStockTransfers}/>

      <GraphQLPagination 
        edges={data?.carts?.edges || []}
        pageInfo={data?.carts?.pageInfo || {}}
      />


      
    </PageBodyWrapper>
  )
}

export default AbandonedCart